export default __webpack_public_path__ + "static/media/amex.240df113.png";